import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { confidenceCheckerAdminKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

interface SetDesignTypeInput {
  designTypeId: number;
  enabled: boolean;
}

async function setDesignType({
  designTypeId,
  enabled,
}: SetDesignTypeInput): Promise<void> {
  await apiClient
    .url(`/confidence-checker-admin/design-types/${designTypeId}`)
    .patch({ enabled })
    .res();
}

export function useSetConfidenceCheckerDesignType(): UseMutationResult<
  void,
  Error,
  SetDesignTypeInput
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setDesignType,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: confidenceCheckerAdminKeys.all,
      });
    },
  });
}
